import ajax from '../http/ajax'

export const getDistributionList = _ => {
    return ajax.get('getDistributionList', _)
}
